module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.document) ? _c('div', {
    staticClass: "view-wrapper about"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.document.title))]), _vm._v(" "), _c('div', [_c('c-flex-content', {
    attrs: {
      "content": _vm.document.flex_content
    }
  })], 1)]), _vm._v(" "), _c('c-team', {
    attrs: {
      "team": _vm.document.team_members
    }
  }), _vm._v(" "), _c('c-clients', {
    attrs: {
      "filter": "all"
    }
  }), _vm._v(" "), (_vm.document.press_release_repeater.length) ? _c('section', {
    staticClass: "about__list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.document.press_release_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.document.press_release_repeater), function(item) {
    return _c('li', {
      staticClass: "about__list__item"
    }, [_c('span', {
      staticClass: "about__list__meta"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h3', {
      staticClass: "about__list__headline"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }))])]) : _vm._e(), _vm._v(" "), (_vm.document.jobs_active) ? _c('section', {
    staticClass: "about__list"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v(_vm._s(_vm.document.jobs_title))]), _vm._v(" "), _c('ul', _vm._l((_vm.document.jobs_repeater), function(item) {
    return _c('li', {
      staticClass: "about__list__item"
    }, [_c('span', {
      staticClass: "about__list__meta"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('h3', {
      staticClass: "about__list__headline"
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    })])])
  }))])]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c5dad2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
// module id = 272
// module chunks = 0